import type { StroomStatus, WsEvent } from '@jerome2/shared';
import { createStore } from '../lib/store.ts';

// De stroom van de maildienst (2.3.2, ticket 28824): de server meldt met stroom.status of mail en agenda als melding binnenkomen (direct
// na de hello en bij elke wijziging). Zolang de stroom verbonden is, komt elke wijziging in Outlook als mail.changed of agenda.changed
// over de websocket en ververst het tabblad Mail alleen als vangnet elke tien minuten; zonder stroom (niet verbonden, terugval, of de
// websocket zelf weg: dan is de stand onbekend) elke minuut, zoals vóór 2.3.2.

export const REFRESH_MS = 60_000;
export const REFRESH_STROOM_MS = 10 * 60_000;

export const stroomStore = createStore<{ status: StroomStatus | null }>({ status: null });

export function applyStroomEvent(ev: WsEvent): void {
  if (ev.type === 'stroom.status') stroomStore.set({ status: ev.status });
}

/** De websocket is weg: de stand van de stroom is onbekend tot de volgende hello. */
export function forgetStroom(): void {
  if (stroomStore.get().status !== null) stroomStore.set({ status: null });
}

/** Hoe vaak het tabblad Mail ververst: met de stroom verbonden als vangnet elke tien minuten, anders elke minuut. */
export function mailRefreshMs(status: StroomStatus | null): number {
  return status === 'connected' ? REFRESH_STROOM_MS : REFRESH_MS;
}
